export default function getNameFromEmail (email) {
    if (!email) return { firstName: '', lastName: '' };

    const [namePart] = email.split('@');
    const parts = namePart.split(/[._-]/);
    return {
      firstName: parts[0] || '',
      lastName: parts[1] || ''
    };
  };